import Button from "@mui/material/Button";

interface Props {
  onBack: any;
  onNext: any;
}

function CustomButton({ onBack, onNext }: Props) {
  return (
    <div className="mt-10 flex justify-center">
      <Button
        variant="outlined"
        classes={{ outlined: "!rounded-lg" }}
        onClick={onBack}
        className="!text-black !uppercase h-13 w-37.5 rounded-lg !mr-10"
      >
        Back
      </Button>
      <Button
        variant="contained"
        classes={{ contained: "!rounded-lg" }}
        onClick={onNext}
        className="!uppercase h-13 w-37.5 rounded-lg"
      >
        NEXT
      </Button>
    </div>
  );
}

export default CustomButton;
